import React from 'react';
import { Link, Redirect, Route } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthContext';

const AdminRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, isAdmin, adminPermissionLoading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          const requestedPath = `${props.location.pathname}${props.location.search}`;
          return <Redirect to={`/login?redirect=${encodeURIComponent(requestedPath)}`} />;
        }
        if (adminPermissionLoading) {
          return (
            <main className="canvas-admin-route-state" role="status">
              正在验证管理员权限…
            </main>
          );
        }
        if (!isAdmin) {
          return (
            <main className="canvas-admin-route-state" role="alert">
              <h1>无管理员权限</h1>
              <p>当前账号不能访问管理页面。</p>
              <Link to="/">返回灵感画布</Link>
            </main>
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default AdminRoute;
